import { render, staticRenderFns } from "./OpenCloseSwitch.vue?vue&type=template&id=d34856d8&"
import script from "./OpenCloseSwitch.vue?vue&type=script&lang=js&"
export * from "./OpenCloseSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports